var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-center main-sub-title"},[_vm._v("selected element")]),_vm._v(" "),_c('h2',{staticClass:"text-center main-title"},[_vm._v("Vertical Divider")]),_vm._v(" "),_c('div',{staticClass:"preview-box",style:({width : _vm.previewBoxWidth})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb1f1aaa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/VerticalDivider.vue
// module id = null
// module chunks = 